























import { Component, Mixins } from "vue-mixin-decorator";
import { Prop } from "vue-property-decorator";
import SButton from "@/app/basic/common/components/SButton.vue";
import ComponentVue from "@/app/core/window/ComponentVue";
import VueEvent from "@/app/core/decorator/VueEvent";

@Component({ components: { SButton } })
export default class CardDeckSubContainerComponent extends Mixins<ComponentVue>(
  ComponentVue
) {
  @Prop({ type: String, required: true })
  private message!: string;

  @Prop({ type: Object, default: undefined })
  private messageArg!: any;

  @Prop({ type: Boolean, default: false })
  private isFirst!: boolean;

  @Prop({ type: Boolean, default: false })
  private isLast!: boolean;

  @Prop({ type: Boolean, default: false })
  private nextDisabled!: boolean;

  @VueEvent
  private get msgText() {
    return this.$t(
      `card-deck-builder.message-list.${this.message}`,
      this.messageArg
    );
  }
}
